import React from 'react';
import { Container, Row, Col } from 'themes/MoGrid';
import { Wrapper, PartnerContainer, PartnerRow, TitleUnderline, LogoContainer, StyledImg, Link } from './partner.style';
import helper from 'components/utils/helper';

const Partner = ({partners, copyright, more}) => {
    const isOnMobile = helper.isOnMobile();
    const noOfLogos = isOnMobile ? 2 : 4;
    const [promoActive, setPromoActive] = React.useState(isOnMobile ? [0,1] : [0,1,2,3]);
    const [fundActive, setFundActive] = React.useState(isOnMobile ? [0,1] : [0,1,2,3]);
    const [promoRotatePos, setPromoRotatePos] = React.useState(0);
    const [fundRotatePos, setFundRotatePos] = React.useState(0);

    helper.useInterval(() => {
        if(partners.length > 0){
            if(partners[1]){
                rotateLogos('promo');
            }
            if(partners[2]){
                rotateLogos('fund');
            }
        }
    }, 3000);

    function rotateLogos(type){
        let isPromo = type === 'promo';
        let logoList = isPromo ? partners[1].items : partners[2].items;
        let rotatePos = isPromo ? promoRotatePos : fundRotatePos;

        if(isOnMobile){
            setPromoActive([0,1]);
            setFundActive([0,1]);
        } else {
            setPromoActive([0,1,2,3]);
            setFundActive([0,1,2,3]);
        }
        let newActiveArray = [...isPromo ? promoActive: fundActive];
        let newLogo = null, counter = 0; // set counter to avoid infinite loop
        do {
            newLogo = Math.floor(Math.random() * logoList.length);
            counter++;
        } while (newActiveArray.indexOf(newLogo) >= 0 && counter < 10)

        if(newLogo !== null && counter < 10){
            newActiveArray[rotatePos] = newLogo;
            isPromo ? setPromoActive(newActiveArray) : setFundActive(newActiveArray);
        }

        if(isOnMobile){
            if(isPromo){
                (rotatePos === 1) ? setPromoRotatePos(0) : setPromoRotatePos(rotatePos + 1);
            } else {
                (rotatePos === 1) ? setFundRotatePos(0) : setFundRotatePos(rotatePos + 1);
            }
        } else {
            if(isPromo){
                (rotatePos === 3) ? setPromoRotatePos(0) : setPromoRotatePos(rotatePos + 1);
            } else {
                (rotatePos === 3) ? setFundRotatePos(0) : setFundRotatePos(rotatePos + 1);
            }
        }
    }

    return ( 
        <Wrapper>
            <PartnerContainer>
                <Container>
                    {partners.map((partner, i) =>
                        <React.Fragment key={i}>
                            { partner.items.length > 0 &&
                                <PartnerRow>
                                    <TitleUnderline>{partner.title}</TitleUnderline>
                                    {/* Maximum 4 partners on desktop, 2 on mobile, if there are more than 4 then have to rotate */}
                                    <Row>
                                        { partner.type === 'major'
                                            ? <React.Fragment>
                                                    {partner.items.map((partner, index) => 
                                                        <Col sm={3} xs={6} key={index}>
                                                            <LogoContainer>
                                                                <Link href={partner.link ? partner.link : "#"} target={"_blank"} rel="noreferrer" isActive={true}>
                                                                <StyledImg isActive={true} src={helper.getLegacyAssetUrl('image', partner.logo)} name={partner.name} alt={partner.name}></StyledImg>
                                                                </Link>
                                                            </LogoContainer>
                                                        </Col>
                                                    )}
                                                </React.Fragment>
                                            : <React.Fragment>
                                                {[...Array(noOfLogos)].map((ele, index) => {
                                                    return <Col item sm={3} xs={6} key={index}>
                                                                <LogoContainer>
                                                                    {partner.items.map((partner, i) => 
                                                                        <React.Fragment  key={i}>
                                                                        <Link href={partner.link ? partner.link : "#"} target={"_blank"} rel="noreferrer" isActive={(partner.type === 'promo') ? i === promoActive[index] : i === fundActive[index]}>
                                                                            <StyledImg onClick={() => window.location = partner.link}
                                                                                isActive={(partner.type === 'promo') ? i === promoActive[index] : i === fundActive[index]}
                                                                                src={helper.getLegacyAssetUrl('image', partner.logo)} name={partner.name} alt={partner.name}>
                                                                            </StyledImg>
                                                                        </Link>
                                                                        </React.Fragment>
                                                                    )}
                                                                </LogoContainer>
                                                            </Col>
                                                })}
                                            </React.Fragment>
                                        }
                                    </Row>
                                </PartnerRow>
                            }
                        </React.Fragment>
                        
                    )}
                </Container>
            </PartnerContainer>
        </Wrapper>
    );
}
 
export default Partner;
